import React from 'react';
import { Button, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { IconHeader } from '../../Professor/ProfessorInputGrades/css';


export default class CourseList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true

        };
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getCourse = this.getCourse.bind(this);
    }
    // imam pristup id ankete proslijedjen preko location(link)
    componentDidMount() {
        localStorage.removeItem('defIndex');
        this.getCourse();
    }
    getCourse() {
        // treba da se vrate svi predmeti a ne samo koji imaju odg
        let obj = {
            id: null
        };

        axios.post(`/questionnaire/staff-results/course-implementations/${JSON.parse(localStorage.getItem('poll')).pollId}/`, { ...obj })
            .then(res => {
                const courses = res.data;
                this.setState({ data: courses, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
                console.log('Failed to fetch courses.');
            });
    }


    getDataToRender() {
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }


    render() {
        if (this.state.showResults === true) {
            return (<FormattedMessage id="route.pollResults">
                {(msg) => (<Redirect push to={{ pathname: msg }} />)}
            </FormattedMessage>);
        }
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1"> <FormattedMessage id="poll.polls" /> </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> <FormattedMessage id="common.courses" />
                        <Header style={IconHeader} floated="right" >
                            <Icon />
                            <Popup
                                trigger={<Icon
                                    link
                                    circular
                                    basic="true"
                                    floated="right"
                                    name="arrow left"
                                    onClick={() => window.history.go(-1)}
                                />}
                                content={<FormattedMessage id="common.back" />}
                                hideOnScroll
                                position="top center"
                            />
                        </Header></Header></Segment>
                    <Segment>
                        { this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                            this.state.data.length ?
                                <Table celled selectable compact>
                                    <Table.Header>
                                        <Table.Row >
                                            <Table.HeaderCell >
                                                <FormattedMessage id="common.course"/>
                                            </Table.HeaderCell>
                                            <Table.HeaderCell >
                                                <FormattedMessage id="common.group" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell >
                                                <FormattedMessage id="poll.numberOfStudentsOnCourse" />
                                            </Table.HeaderCell>
                                            <Table.HeaderCell >
                                                <FormattedMessage id="poll.numberOfStudentsWhoDoneCourse" />

                                            </Table.HeaderCell>
                                            <Table.HeaderCell >{localStorage.getItem('activeRole').substr(0, 8) === 'Asistent' ? <FormattedMessage id="poll.numberOfStudentsWhoDoneAssistant" /> : <FormattedMessage id="poll.numberOfStudentsWhoDoneProfessor" />}


                                            </Table.HeaderCell>
                                            <Table.HeaderCell width={1}>
                                                <FormattedMessage id="common.average" />

                                            </Table.HeaderCell>

                                            <Table.HeaderCell></Table.HeaderCell>


                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {this.getDataToRender().map((el, index) =>
                                            el.numberOfStudentsOnCourse === -1 ?
                                                (<Table.Row
                                                    key={index}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (el.numberOfStudentsWhoRatedCourse || el.numberOfStudentsWhoRatedEmployee) {
                                                            localStorage.setItem('courseId', el.courseImplementationId);
                                                            localStorage.setItem('courseName', el.courseImplementationName);
                                                            localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                            localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                            localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedCourse', el.numberOfStudentsWhoRatedCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                            this.setState({ showResults: true });
                                                        }
                                                    }}
                                                >
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.courseImplementationName ? el.courseImplementationName : '/'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" colSpan={6} textAlign="center">
                                                        <FormattedMessage id="poll.lateImplementationMess" />

                                                    </Table.Cell>
                                                </Table.Row>)
                                                :
                                                (<Table.Row
                                                    key={index}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (el.numberOfStudentsWhoRatedCourse || el.numberOfStudentsWhoRatedEmployee) {
                                                            localStorage.setItem('courseId', el.courseImplementationId);
                                                            localStorage.setItem('courseName', el.courseImplementationName);
                                                            localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                            localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                            localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedCourse);
                                                            localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                            this.setState({ showResults: true });
                                                        }
                                                    }}
                                                >
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.courseImplementationName ? el.courseImplementationName : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.groupName ? el.groupName : '-'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.numberOfStudentsOnCourse ? el.numberOfStudentsOnCourse : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.numberOfStudentsWhoRatedCourse ? el.numberOfStudentsWhoRatedCourse : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.numberOfStudentsWhoRatedEmployee ? el.numberOfStudentsWhoRatedEmployee : '0'}
                                                    </Table.Cell>
                                                    <Table.Cell
                                                        verticalAlign="middle"
                                                        warning={parseFloat(el.averageGradeStaff).toFixed(2) >= 2 && parseFloat(el.averageGradeStaff).toFixed(2) <= 4}
                                                        positive={parseFloat(el.averageGradeStaff).toFixed(2) > 4}
                                                        negative={parseFloat(el.averageGradeStaff).toFixed(2) < 2 && el.averageGradeStaff !== -1}
                                                    >
                                                        {isNaN(el.averageGradeStaff) ||
                                                        parseFloat(el.averageGradeStaff).toFixed(2) === 'NaN' ||
                                                        JSON.stringify(el.averageGradeStaff) === 'NaN' ||
                                                        parseFloat(el.averageGradeStaff).toFixed(2) === '-1.00'
                                                            ? '-' : parseFloat(el.averageGradeStaff).toFixed(2)}
                                                        {/*{el.averageGradeStaff !== -1 ? parseFloat(el.averageGradeStaff).toFixed(2) : '-'}*/}
                                                        {/* {parseFloat(el.averageGradeStaff).toFixed(2) < 2 && <Icon color="red" name="attention" />} */}
                                                        {/* {parseFloat(el.averageGradeStaff).toFixed(2) > 4 && <Icon color="green" name="checkmark" />} */}
                                                        {/* {parseFloat(el.averageGradeStaff).toFixed(2)} */}
                                                    </Table.Cell>


                                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                                        {/* link */}

                                                        <Button
                                                            onClick={() => {
                                                                localStorage.setItem('courseId', el.courseImplementationId);
                                                                localStorage.setItem('courseName', el.courseImplementationName);
                                                                localStorage.setItem('courseImplementationGroupId', el.courseImplementationGroupId);
                                                                localStorage.setItem('courseImplementationGroupName', el.groupName);
                                                                localStorage.setItem('numberOfStudentsOnCourse', el.numberOfStudentsOnCourse);
                                                                localStorage.setItem('numberOfStudentsWhoRatedEmployee', el.numberOfStudentsWhoRatedEmployee);
                                                                this.setState({ showResults: true });
                                                            }}
                                                            disabled={!el.numberOfStudentsWhoRatedCourse && !el.numberOfStudentsWhoRatedEmployee}
                                                            basic="true"
                                                            color="blue"
                                                            size="small"
                                                        >
                                                            {/* <Link to={{ */}
                                                            {/*    pathname: '/ankete/predmeti/rezultati', */}
                                                            {/* }} */}
                                                            {/* > */}
                                                            <FormattedMessage id="poll.results" />
                                                            {/* </Link> */}
                                                        </Button>


                                                    </Table.Cell>
                                                </Table.Row>))}
                                    </Table.Body>

                                </Table> : <FormattedMessage id="poll.noCoursesAssigned" />}
                    </Segment>
                </Segment.Group>

            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/CourseList.js